// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../../shared/src/Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../shared/src/IOUtils.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var ReactIO = require("../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../shared/src/DomUtils.bs.js");
var Reselect = require("../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("./store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactDOMRe = require("reason-react/src/legacy/ReactDOMRe.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Jwt = require("../../shared/src/types/CommonTypes_Jwt.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("./store/WebStore_Selectors.bs.js");
var WebContainers_Login = require("./containers/login/WebContainers_Login.bs.js");
var WebContainers_Logout = require("./containers/WebContainers_Logout.bs.js");
var WebContainers_Welcome = require("./containers/WebContainers_Welcome.bs.js");
var WebStore_Types_Action = require("./store/WebStore_Types_Action.bs.js");
var WebComponents_ErrorPage = require("./components/WebComponents_ErrorPage.bs.js");
var WebContainers_EditShift = require("./containers/WebContainers_EditShift.bs.js");
var BrowserComponents_Button = require("../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var WebContainers_PostAShift = require("./containers/post-a-shift/WebContainers_PostAShift.bs.js");
var BrowserComponents_Loading = require("../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var WebContainers_GetBusinessApp = require("./containers/WebContainers_GetBusinessApp.bs.js");
var WebContainers_Login_Business = require("./containers/login/WebContainers_Login_Business.bs.js");
var WebComponents_GoogleAnalytics = require("./components/WebComponents_GoogleAnalytics.bs.js");
var WebContainers_Signup_Business = require("./containers/signup/WebContainers_Signup_Business.bs.js");
var WebComponents_GoogleTagManager = require("./components/WebComponents_GoogleTagManager.bs.js");
var WebContainers_BusinessDashboard = require("./containers/business-dashboard/WebContainers_BusinessDashboard.bs.js");
var WebContainers_GetProfessionalApp = require("./containers/WebContainers_GetProfessionalApp.bs.js");
var WebContainers_Login_ResetPassword = require("./containers/login/WebContainers_Login_ResetPassword.bs.js");
var WebContainers_Signup_Professional = require("./containers/signup/WebContainers_Signup_Professional.bs.js");
var WebContainers_Login_ForgotPassword = require("./containers/login/WebContainers_Login_ForgotPassword.bs.js");
var WebComponents_SimpleCenteredLogoPage = require("./components/WebComponents_SimpleCenteredLogoPage.bs.js");

function Web$App$Authenticated$Business(Props) {
  var authorizedClient = Props.authorizedClient;
  var setView = Props.setView;
  var user = Props.user;
  var view = Props.view;
  var tmp;
  if (typeof view === "number") {
    tmp = view === /* Welcome */1 ? Curry._1(setView, {
            TAG: /* BusinessDashboard */0,
            _0: {
              TAG: /* ShiftsList */1,
              _0: /* Upcoming */1
            }
          }) : Relude_IO.pure(undefined);
  } else {
    switch (view.TAG | 0) {
      case /* Login */3 :
      case /* ResetPassword */5 :
      case /* Signup */6 :
          tmp = Curry._1(setView, {
                TAG: /* BusinessDashboard */0,
                _0: {
                  TAG: /* ShiftsList */1,
                  _0: /* Upcoming */1
                }
              });
          break;
      default:
        tmp = Relude_IO.pure(undefined);
    }
  }
  ReactIO.useHandledIOOnMount(undefined)(tmp);
  if (typeof view === "number") {
    return null;
  }
  switch (view.TAG | 0) {
    case /* BusinessDashboard */0 :
        return React.createElement(WebContainers_BusinessDashboard.make, {
                    authorizedClient: authorizedClient,
                    currentDashboardView: view._0,
                    user: user
                  });
    case /* EditShift */1 :
        return React.createElement(WebContainers_EditShift.make, {
                    editShiftId: view._0,
                    user: user
                  });
    case /* GetApp */2 :
        return React.createElement(WebContainers_GetBusinessApp.make, {});
    case /* PostAShift */4 :
        var tmp$1 = {
          user: user
        };
        if (view._0 !== undefined) {
          tmp$1.copyFromShiftId = Caml_option.valFromOption(view._0);
        }
        return React.createElement(WebContainers_PostAShift.make, tmp$1);
    default:
      return null;
  }
}

var Business = {
  make: Web$App$Authenticated$Business
};

function Web$App$Authenticated(Props) {
  var authorizedClient = Props.authorizedClient;
  var fetchUser = Props.fetchUser;
  var logout = Props.logout;
  var setView = Props.setView;
  var user = Props.user;
  var view = Props.view;
  ReactIO.useHandledIOOnMount(undefined)(fetchUser);
  var partial_arg = React.createElement(WebComponents_ErrorPage.make, {
        children: null,
        description: "It looks like there was a system issue loading your account. You may want to try logging out and back in.",
        title: "Oh no!"
      }, React.createElement(BrowserComponents_Spacer.make, {
            size: /* Large */5
          }), React.createElement(BrowserComponents_Button.make, {
            actionPriority: /* LegacyTertiary */3,
            onClick: (function (param) {
                return logout;
              }),
            title: "Logout"
          }));
  return Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.$$Screen.make, {}), (function (user) {
                if (typeof user === "number") {
                  if (user !== 0) {
                    return React.createElement(WebContainers_Logout.make, {});
                  } else {
                    return React.createElement(WebContainers_GetProfessionalApp.make, {});
                  }
                } else {
                  return React.createElement(Web$App$Authenticated$Business, {
                              authorizedClient: authorizedClient,
                              setView: setView,
                              user: user._0,
                              view: view
                            });
                }
              }), (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), user);
}

var Authenticated = {
  Business: Business,
  make: Web$App$Authenticated
};

Curry._2(BrowserStyle.$$global, "html", {
      hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
      tl: /* [] */0
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* Medium */3, /* Normal */0);
}

Curry._2(BrowserStyle.$$global, "body", Curry._1(arg(undefined), {
          hd: BrowserStyle.backgroundAttachment("fixed"),
          tl: {
            hd: BrowserStyle.backgroundImage(BrowserStyle.url(BrowserStyle.$$Image.qwickWhiteBg)),
            tl: {
              hd: BrowserStyle.backgroundRepeat("repeat"),
              tl: {
                hd: BrowserStyle.backgroundSize({
                      NAME: "size",
                      VAL: [
                        BrowserStyle.rem(45.0),
                        BrowserStyle.rem(30.0)
                      ]
                    }),
                tl: {
                  hd: BrowserStyle.color({
                        TAG: /* Grey */2,
                        _0: /* Dark */1
                      }),
                  tl: {
                    hd: BrowserStyle.margin(BrowserStyle.zero),
                    tl: {
                      hd: BrowserStyle.padding(BrowserStyle.zero),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }));

Curry._2(BrowserStyle.$$global, "li", {
      hd: BrowserStyle.listStyleType(BrowserStyle.none),
      tl: /* [] */0
    });

Curry._2(BrowserStyle.$$global, "li:hover", {
      hd: BrowserStyle.cursor("pointer"),
      tl: /* [] */0
    });

Curry._2(BrowserStyle.$$global, "button:hover", {
      hd: BrowserStyle.cursor("pointer"),
      tl: /* [] */0
    });

Curry._2(BrowserStyle.$$global, "a", {
      hd: BrowserStyle.color({
            TAG: /* Teal */6,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.textDecoration(BrowserStyle.none),
        tl: /* [] */0
      }
    });

Curry._2(BrowserStyle.$$global, "input[type=time]::-webkit-inner-spin-button, input[type=time]::-webkit-outer-spin-button", {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Dark */1
          }),
      tl: {
        hd: BrowserStyle.unsafe("-webkit-appearance", "none"),
        tl: /* [] */0
      }
    });

Curry._2(BrowserStyle.$$global, "input[type=time]", {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Dark */1
          }),
      tl: {
        hd: BrowserStyle.backgroundColor({
              TAG: /* White */7,
              _0: /* Light */2
            }),
        tl: {
          hd: BrowserStyle.unsafe("-webkit-appearance", "none"),
          tl: /* [] */0
        }
      }
    });

Curry._2(BrowserStyle.$$global, "input[type=time]::-webkit-datetime-edit", {
      hd: BrowserStyle.textAlign(BrowserStyle.center),
      tl: /* [] */0
    });

function arg$1(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* Large */4, /* Semibold */1);
}

Curry._2(BrowserStyle.$$global, "#PlacesAutocomplete__autocomplete-container", Curry._1(arg$1(undefined), {
          hd: BrowserStyle.zIndex(99),
          tl: /* [] */0
        }));

function arg$2(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* Large */4, /* Semibold */1);
}

Curry._2(BrowserStyle.$$global, "#PlacesAutocomplete__root input", Curry._1(arg$2(undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Dark */1
              }),
          tl: {
            hd: BrowserStyle.important(BrowserStyle.padding(BrowserStyle.rem(0.75))),
            tl: {
              hd: BrowserStyle.important(BrowserStyle.paddingLeft(BrowserStyle.rem(2.5))),
              tl: {
                hd: BrowserStyle.border(BrowserStyle.Input.borderWidth, "solid", {
                      TAG: /* Grey */2,
                      _0: /* Light */3
                    }),
                tl: {
                  hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
                  tl: {
                    hd: BrowserStyle.textAlign("left"),
                    tl: {
                      hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                      tl: {
                        hd: BrowserStyle.outlineStyle(BrowserStyle.none),
                        tl: {
                          hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }));

Curry._2(BrowserStyle.$$global, "#PlacesAutocomplete__root", {
      hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
      tl: /* [] */0
    });

var Styles = {};

var partial_arg = Curry._1(Relude_Option.flatMap, CommonTypes_Jwt.fromString);

var partial_arg$1 = Curry._1(Relude_Option.flatMap, (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_String.splitArray(" ", param);
                    }), Relude_Array.last, param);
      }));

var partial_arg$2 = Curry._1(Relude_Option.flatMap, (function (__x) {
        return Js_dict.get(__x, "authorization");
      }));

var partial_arg$3 = Curry._1(Relude_Option.flatMap, Curry._1(Json.Decode.$$Option.dict, Json.Decode.$$Option.string));

function partial_arg$4(param) {
  return Relude_Globals.$great$great(Json.Decode.$$Option.parseStringToJson, partial_arg$3, param);
}

function partial_arg$5(param) {
  return Relude_Globals.$great$great(partial_arg$4, partial_arg$2, param);
}

function partial_arg$6(param) {
  return Relude_Globals.$great$great(partial_arg$5, partial_arg$1, param);
}

function getTokenFromDomStorageValue(param) {
  return Relude_Globals.$great$great(partial_arg$6, partial_arg, param);
}

function convertAuthHeaderToToken(finishLoginBusiness) {
  return Relude_Option.fold(Relude_IO.pure(undefined), (function (token) {
                return Relude_IO.flatMap((function (param) {
                              return Curry._1(finishLoginBusiness, token);
                            }), Relude_IO.suspend(function (param) {
                                localStorage.removeItem("auth_headers");
                                
                              }));
              }), Curry._2(Relude_Option.flatMap, getTokenFromDomStorageValue, Caml_option.null_to_opt(localStorage.getItem("auth_headers"))));
}

function Web$App$Presentation(Props) {
  var authorizedClient = Props.authorizedClient;
  var fetchCities = Props.fetchCities;
  var fetchUser = Props.fetchUser;
  var finishLoginBusiness = Props.finishLoginBusiness;
  var logout = Props.logout;
  var onUrlChange = Props.onUrlChange;
  var setView = Props.setView;
  var startCurrentDatetimeUpdate = Props.startCurrentDatetimeUpdate;
  var stopCurrentDatetimeUpdate = Props.stopCurrentDatetimeUpdate;
  var view = Props.view;
  var updateLayoutFromDom = Props.updateLayoutFromDom;
  var user = Props.user;
  ReactIO.useIOOnMount((function (param) {
          return Relude_Result.fold(Relude_IO.pure, DomUtils.Router.unwatchUrl, param);
        }), undefined, DomUtils.Router.watchUrl(onUrlChange));
  ReactIO.useHandledIOOnMount((function (param) {
            return Relude_Globals.$$const(stopCurrentDatetimeUpdate, param);
          }))(startCurrentDatetimeUpdate);
  ReactIO.useHandledIOOnMount(undefined)(Relude_IO.suspend(function (param) {
            return Relude_Option.getOrElse(undefined, DomUtils.WindowSizing.subscribeToResizeEvents(function (param) {
                            return IOUtils.unsafeRunHandledAsync(updateLayoutFromDom);
                          }));
          }));
  ReactIO.useHandledIOOnMount(undefined)(convertAuthHeaderToToken(finishLoginBusiness));
  ReactIO.useHandledIOOnMount(undefined)(fetchCities);
  var tmp;
  var exit = 0;
  if (typeof view === "number" && view === 0) {
    tmp = React.createElement(WebContainers_Logout.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (authorizedClient !== undefined) {
      tmp = React.createElement(Web$App$Authenticated, {
            authorizedClient: Caml_option.valFromOption(authorizedClient),
            fetchUser: fetchUser,
            logout: logout,
            setView: setView,
            user: user,
            view: view
          });
    } else {
      var exit$1 = 0;
      if (typeof view === "number") {
        if (view === /* Welcome */1) {
          tmp = React.createElement(WebContainers_Welcome.make, {});
        } else {
          exit$1 = 2;
        }
      } else {
        switch (view.TAG | 0) {
          case /* GetApp */2 :
              tmp = view._0 ? React.createElement(WebContainers_GetProfessionalApp.make, {}) : React.createElement(WebContainers_GetBusinessApp.make, {});
              break;
          case /* Login */3 :
              switch (view._0) {
                case /* Business */0 :
                    exit$1 = 2;
                    break;
                case /* ForgotPassword */1 :
                    tmp = React.createElement(WebContainers_Login_ForgotPassword.make, {});
                    break;
                case /* Unknown */2 :
                    tmp = React.createElement(WebContainers_Login.make, {});
                    break;
                
              }
              break;
          case /* ResetPassword */5 :
              tmp = React.createElement(WebContainers_Login_ResetPassword.make, {
                    resetToken: view._0
                  });
              break;
          case /* Signup */6 :
              var view$1 = view._0;
              tmp = view$1.TAG === /* Business */0 ? React.createElement(WebContainers_Signup_Business.make, {
                      view: view$1._0
                    }) : React.createElement(WebContainers_Signup_Professional.make, {
                      view: view$1._0
                    });
              break;
          default:
            exit$1 = 2;
        }
      }
      if (exit$1 === 2) {
        tmp = React.createElement(WebContainers_Login_Business.make, {});
      }
      
    }
  }
  return React.createElement(React.Fragment, undefined, React.createElement(WebComponents_GoogleTagManager.make, {}), React.createElement(WebComponents_GoogleAnalytics.make, {
                  view: view
                }), tmp);
}

var Presentation = {
  make: Web$App$Presentation
};

var mapStateToProps = Reselect.createSelector3(undefined, WebStore_Selectors.getAuthorizedClient, (function (param) {
        return param.currentUser;
      }), (function (param) {
        return param.view;
      }), (function (authorizedClient, user, view) {
        return {
                authorizedClient: authorizedClient,
                user: user,
                view: view
              };
      }));

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$2 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg_fetchCities = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.fetchCities));
  var partial_arg_fetchUser = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.fetchUser));
  var partial_arg_finishLoginBusiness = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.finishLoginBusiness, dispatch, param);
                }), partial_arg, param);
  };
  var partial_arg_logout = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.logout));
  var partial_arg_onUrlChange = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.updateFromUrl, dispatch, param);
                }), partial_arg$1, param);
  };
  var partial_arg_setView = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                }), partial_arg$2, param);
  };
  var partial_arg_startCurrentDatetimeUpdate = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.timing(WebStore_Types_Action.Timing.startCurrentDatetimeUpdate)));
  var partial_arg_stopCurrentDatetimeUpdate = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.timing(WebStore_Types_Action.Timing.stopCurrentDatetimeUpdate)));
  var partial_arg_updateLayoutFromDom = Curry._2(Relude_IO.mapError, (function (prim) {
          
        }), Curry._1(dispatch, WebStore_Types_Action.updateLayoutFromDom));
  var partial_arg$3 = {
    fetchCities: partial_arg_fetchCities,
    fetchUser: partial_arg_fetchUser,
    finishLoginBusiness: partial_arg_finishLoginBusiness,
    logout: partial_arg_logout,
    onUrlChange: partial_arg_onUrlChange,
    setView: partial_arg_setView,
    startCurrentDatetimeUpdate: partial_arg_startCurrentDatetimeUpdate,
    stopCurrentDatetimeUpdate: partial_arg_stopCurrentDatetimeUpdate,
    updateLayoutFromDom: partial_arg_updateLayoutFromDom
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$3, param);
  };
}

function Web$App(Props) {
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  if (DomUtils.isIE(undefined)) {
                    return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                                subtitle: "For best results, we recommend using Safari, Chrome, or Firefox.",
                                title: "Your Browser is Unsupported"
                              });
                  } else {
                    return React.createElement(Web$App$Presentation, {
                                authorizedClient: param.authorizedClient,
                                fetchCities: param$1.fetchCities,
                                fetchUser: param$1.fetchUser,
                                finishLoginBusiness: param$1.finishLoginBusiness,
                                logout: param$1.logout,
                                onUrlChange: param$1.onUrlChange,
                                setView: param$1.setView,
                                startCurrentDatetimeUpdate: param$1.startCurrentDatetimeUpdate,
                                stopCurrentDatetimeUpdate: param$1.stopCurrentDatetimeUpdate,
                                view: param.view,
                                updateLayoutFromDom: param$1.updateLayoutFromDom,
                                user: param.user
                              });
                  }
                })
            });
}

var App = {
  Authenticated: Authenticated,
  Styles: Styles,
  Presentation: Presentation,
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps,
  make: Web$App
};

ReactDOMRe.renderToElementWithId(React.createElement(Web$App, {}), "index");

exports.App = App;
/*  Not a pure module */
